import { render, staticRenderFns } from "./MetaSignupButton.vue?vue&type=template&id=45dba1ce"
import script from "./MetaSignupButton.vue?vue&type=script&lang=js"
export * from "./MetaSignupButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports